import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalService } from '@bewatec-berlin/gentics-ui-core';

import { MeshNode } from '../../../common/models/node.model';
import * as NodeUtil from '../../../common/util/node-util';
import { ConfirmUnpublishedModalComponent } from '../../../editor/components/confirm-unpublished-modal/confirm-unpublished-modal.component';
import { EditorEffectsService } from '../../../editor/providers/editor-effects.service';

@Component({
    selector: 'mesh-publish-options',
    templateUrl: './publish-options.component.html',
    styleUrls: ['./publish-options.component.scss']
})
export class PublishOptionsComponent implements OnInit {
    @Input() node: MeshNode;

    @Input() beforePublish: () => Promise<any> | undefined;

    nodeUtil = NodeUtil;

    constructor(private editorEffects: EditorEffectsService, private modalService: ModalService) {}

    ngOnInit() {}

    async publishNode() {
        if (this.beforePublish) {
            await this.beforePublish();
        }
        this.editorEffects.publishNode(this.node);
    }

    async publishNodeLanguage() {
        if (this.beforePublish) {
            await this.beforePublish();
        }
        this.editorEffects.publishNodeLanguage(this.node);
    }

    unpublishNode(): void {
        if (!this.node.container) {
            this.editorEffects.unpublishNode(this.node);
        } else {
            const options = {
                closeOnOverlayClick: false
            };
            this.modalService
                .fromComponent(ConfirmUnpublishedModalComponent, options, { node: this.node })
                .then(modal => modal.open());
        }
    }

    unpublishNodeLanguage(): void {
        this.editorEffects.unpublishNodeLanguage(this.node);
    }
}
